import { Condition } from './Condition';
import { Unit } from './Unit';
import { FreightConditionDTO } from '../../dto';

interface FreightProps {
  condition: Condition;
  percentAddon?: number;
  fixedAddOn?: number;
  fixedAddOnUnit?: Unit;
}

export class FreightCondition {
  condition: Condition;
  percentAddon?: number;
  fixedAddOn?: number;
  fixedAddOnUnit?: Unit;

  constructor(props: FreightProps) {
    this.condition = props.condition;
    this.percentAddon = props.percentAddon;
    this.fixedAddOn = props.fixedAddOn;
    this.fixedAddOnUnit = props.fixedAddOnUnit;
  }

  static fromDto = (dto: FreightConditionDTO): FreightCondition =>
    new FreightCondition({
      condition: Condition.fromDto(dto.condition),
      percentAddon: dto.percentAddon,
      fixedAddOn: dto.fixedAddOn,
      fixedAddOnUnit: dto.fixedAddOnUnit ? Unit.fromDto(dto.fixedAddOnUnit) : undefined,
    });
}
